<gs-dialog *ngIf="employeeId"
           dialogCss="pos-details"
           [header]="item?.data ? (detailsHeader | joinSumaCalculation:item.data:'PaymentDue') : detailsHeader"
           [(visible)]="employeeId"
           modal="true"
           closable="true"
           [editLevel]="0"
           (visibleChange)="onDialogClose($event)">
  <ng-template pTemplate="gsDialogContent">
    <div class="col-lg-12" style="padding: 0; background-color: var(--content-main-background-color-light);">
      <div *ngIf="item" style="margin: 10px">
        <gs-table change
                  [wide]="true"
                  [readOnly]="true"
                  [columns]="columns"
                  [(pageSize)]="pageSize"
                  [itemName]="itemName"
                  [showPaginator]="true"
                  [items]="item.items"
                  [pagedResultsRequestKey]="'ShiftsFilter'">
        </gs-table>
      </div>
    </div>
  </ng-template>
